// extracted by mini-css-extract-plugin
module.exports = {"OrgFCListBase":"OrgCommentFCList_OrgFCListBase__Ida--","OrgFCListItem":"OrgCommentFCList_OrgFCListItem__1jEAH"};